<span *ngIf="trainOption == '1'">{{ 'AITopic::TopicTrainWithBothStartedMessage' | abpLocalization: dataCount }}</span>

<span *ngIf="trainOption == '2' || !trainOption">{{ 'AITopic::TopicTrainWithDialoguesStartedMessage' | abpLocalization: dataCount }}</span>

<span *ngIf="trainOption == '3'">{{ 'AITopic::TopicTrainWithCategoriesStartedMessage' | abpLocalization }}</span>
